"use strict";

exports.__esModule = true;
exports["default"] = Home;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Home(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M26.069 4.962a1.259 1.259 0 1 0-2.518 0v2.094l2.518 2.52V4.962zm5.498 11.503L16.861 1.751a1.276 1.276 0 0 0-.843-.356L16 1.384l-.008.005c-.009 0-.015-.005-.025-.005-.169 0-.33.035-.488.102a1.372 1.372 0 0 0-.409.265l-.465.466L.44 16.389a1.252 1.252 0 0 0-.377.894c0 .33.126.651.378.894.488.493 1.29.493 1.786 0L15.985 4.452 29.78 18.253a1.26 1.26 0 0 0 1.786 0 1.261 1.261 0 0 0 .001-1.788zM15.985 5.844L4.769 17.032v13.584h8.101V19.513h6.261v11.103h8.102v-13.52z"
  }));
}